import React from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
export function TestimonialsExtended() {
  const testimonials = [{
    initials: 'JM',
    name: 'Javier M.',
    location: 'Buenos Aires 🇦🇷',
    text: 'Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso.'
  }, {
    initials: 'LG',
    name: 'Laura G.',
    location: 'Córdoba 🇦🇷',
    text: 'Tres alumnos de inicial que estaban estancados mejoraron su técnica desde el primer mes con el Tomo 2.'
  }, {
    initials: 'PR',
    name: 'Pablo R.',
    location: 'Rosario 🇦🇷',
    text: 'Antes tardaba 1 hora armando una clase. Ahora son 5 minutos y la progresión está resuelta.'
  }, {
    initials: 'SV',
    name: 'Sofía V.',
    location: 'Mendoza 🇦🇷',
    text: 'El Bonus de Anatomía Visual cambió cómo corrijo a mis alumnos. Ahora sé exactamente qué decir y por qué.'
  }, {
    initials: 'DA',
    name: 'Diego A.',
    location: 'Santa Fe 🇦🇷',
    text: 'El Manual de Patologías me salvó con un alumno que tenía hernia. Supe exactamente qué adaptar en cada ejercicio.'
  }, {
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Tucumán 🇦🇷',
    text: 'El Diccionario de Variantes cambió cómo manejo los grupos mixtos. Nunca más se para la clase por un alumno que no puede.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-50 border-y border-stone-200" data-id="element-17">
      <div className="max-w-7xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl font-bold text-stone-900 mb-2" data-id="element-20">
            Lo que dicen los profesores
          </h2>
          <p className="text-coral-500 font-bold flex justify-center items-center" data-id="element-21">
            4.9/5 <Star className="w-5 h-5 ml-1 fill-current" data-id="element-22" />
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-23">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-24">
              <div className="flex items-center gap-4 mb-4" data-id="element-25">
                <div className="w-12 h-12 bg-coral-50 rounded-full flex items-center justify-center text-coral-600 font-bold text-lg" data-id="element-26">
                  {t.initials}
                </div>
                <div data-id="element-27">
                  <p className="text-stone-900 font-bold" data-id="element-28">{t.name}</p>
                  <p className="text-stone-500 text-sm" data-id="element-29">{t.location}</p>
                </div>
              </div>
              <p className="text-stone-700 italic" data-id="element-30">"{t.text}"</p>
            </div>)}
        </div>
      </div>
    </section>;
}
export function Guarantee() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-31">
      <div className="bg-white border border-coral-200 rounded-3xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-32">
        <div className="absolute top-0 left-0 w-full h-2 bg-coral-500" data-id="element-33"></div>
        <ShieldCheck className="w-16 h-16 text-coral-500 mx-auto mb-6" data-id="element-34" />
        <h2 className="text-3xl font-bold text-stone-900 mb-6" data-id="element-35">
          🛡️ Garantía 7 días sin preguntas
        </h2>
        <p className="text-lg text-stone-600 mb-8 leading-relaxed" data-id="element-36">
          Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Elite en tu
          clase. Si no es lo que esperabas → 100% de devolución. Sin preguntas.
          Sin formularios. Sin drama.
        </p>
        <div className="inline-block bg-stone-100 text-stone-600 font-bold px-6 py-2 rounded-full text-sm tracking-wider" data-id="element-37">
          TASA DE DEVOLUCIONES MENOR AL 2%
        </div>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago recibís un email con acceso inmediato a todos los archivos PDF. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
    a: 'Sí para los dos casos. El Tomo 1 arranca desde cero técnico. Los tomos avanzados llevan al límite a profes con años de experiencia.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus están incluidos tanto en el Pack Profesional como en el Megapack Elite. Los Ebooks Elite son exclusivos del Megapack.'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'Funcional 360 es el único sistema de planificación para profes de funcional 100% adaptado al contexto argentino, con progresión real de 120 semanas y ejercicios graficados para usar en el campo directamente.'
  }, {
    q: '¿Sirve para grupos con niveles mezclados?',
    a: 'Sí. El Diccionario de Variantes (Elite 1) fue diseñado exactamente para eso. Tenés la regresión y la progresión de cada ejercicio para adaptar en tiempo real.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% del dinero. Sin preguntas ni formularios.'
  }, {
    q: '¿Vale la pena el Megapack Elite si ya planifico bien mis clases?',
    a: 'Sí. El valor real del Megapack no está en la planificación sino en el Manual de Patologías y el Diccionario de Variantes. Son las herramientas que usás cuando la clase se pone difícil y necesitás una respuesta técnica inmediata.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-38">
      <h2 className="text-3xl font-bold text-stone-900 text-center mb-12" data-id="element-39">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4" data-id="element-40">
        {faqs.map((faq, i) => <details key={i} className="group bg-white rounded-xl border border-stone-200 shadow-sm [&_summary::-webkit-details-marker]:hidden" data-id="element-41">
            <summary className="flex items-center justify-between p-6 cursor-pointer text-stone-900 font-bold" data-id="element-42">
              {faq.q}
              <ChevronDown className="w-5 h-5 text-stone-400 group-open:rotate-180 transition-transform" data-id="element-43" />
            </summary>
            <div className="px-6 pb-6 text-stone-600" data-id="element-44">{faq.a}</div>
          </details>)}
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-stone-100 pt-16 pb-8 px-4 sm:px-6 lg:px-8 border-t border-stone-200 text-center" data-id="element-45">
      <div className="max-w-4xl mx-auto" data-id="element-46">
        <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-47">
          💪 FUNCIONAL 360
        </h3>
        <p className="text-stone-600 mb-8" data-id="element-48">
          El sistema de planificación N°1 para profesores de funcional
          argentinos.
        </p>

        <p className="text-coral-600 italic font-medium text-lg mb-12" data-id="element-49">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-stone-500 mb-12" data-id="element-50">
          <span className="flex items-center font-medium" data-id="element-51">
            🏋️ FUNCIONAL 360™
          </span>
          <span className="hidden md:inline text-stone-300" data-id="element-52">|</span>
          <a href="mailto:contacto@funcional360.com.ar" className="hover:text-coral-500 transition-colors" data-id="element-53">
            📧 contacto@funcional360.com.ar
          </a>
          <span className="hidden md:inline text-stone-300" data-id="element-54">|</span>
          <a href="#" className="hover:text-coral-500 transition-colors" data-id="element-55">
            📲 @funcional360.ar
          </a>
          <span className="hidden md:inline text-stone-300" data-id="element-56">|</span>
          <a href="#" className="hover:text-coral-500 transition-colors" data-id="element-57">
            🌐 www.funcional360.ar
          </a>
        </div>

        <p className="text-xs text-stone-400" data-id="element-58">
          © FUNCIONAL 360™ 2025 Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}